import { useState } from "react";
import { Menu, X } from "lucide-react";
import {
    BRAND,
    NAV_LINKS,
    WHATSAPP_URL,
    WhatsAppIcon,
} from "@/lib/site";

export const Header = () => {
    const [open, setOpen] = useState(false);

    return (
        <header className="sticky top-0 z-50 bg-cream">
            <div className="mx-auto grid h-24 max-w-7xl grid-cols-[1fr_auto_1fr] items-center px-4 sm:h-28 sm:px-6">
                <nav
                    className="col-start-1 hidden items-center gap-6 justify-self-start lg:flex"
                    aria-label="Navigazione principale"
                >
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.href.slice(1)}`}
                            className="text-sm font-bold uppercase tracking-wider text-ink underline-offset-4 hover:text-royal hover:underline"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <a
                    href="#top"
                    data-testid="header-logo-link"
                    className="col-start-2 justify-self-center"
                    aria-label="CLEAR LENS MILANO — torna su"
                >
                    <img
                        src="/assets/brand/logo-tr.png"
                        alt="Logo CLEAR LENS MILANO"
                        className="h-20 w-auto sm:h-24"
                        width="96"
                        height="85"
                    />
                </a>

                <div className="col-start-3 flex items-center justify-end gap-3 justify-self-end">
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="header-whatsapp-btn"
                        className="hidden items-center gap-2 border-2 border-ink bg-ink px-4 py-2 text-sm font-bold uppercase tracking-wider text-cream transition-[transform,box-shadow] duration-150 hover:-translate-y-0.5 hover:bg-wa hover:text-ink hover:shadow-print-sm lg:flex"
                    >
                        <WhatsAppIcon className="h-4 w-4" />
                        WhatsApp
                    </a>
                    <button
                        type="button"
                        data-testid="mobile-menu-toggle"
                        className="flex h-11 w-11 items-center justify-center border-2 border-ink bg-cream lg:hidden"
                        aria-expanded={open}
                        aria-label={open ? "Chiudi menu" : "Apri menu"}
                        onClick={() => setOpen((v) => !v)}
                    >
                        {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                    </button>
                </div>
            </div>

            {open && (
                <nav
                    className="border-t-2 border-ink bg-cream px-4 pb-6 pt-2 lg:hidden"
                    aria-label="Navigazione mobile"
                    data-testid="mobile-menu"
                >
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                            className="block border-b border-ink/15 py-3 font-display text-xl font-semibold uppercase tracking-tight"
                            onClick={() => setOpen(false)}
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="mobile-whatsapp-btn"
                        className="mt-4 flex items-center justify-center gap-2 border-2 border-ink bg-wa px-4 py-3 font-display text-lg font-semibold uppercase tracking-tight text-ink"
                    >
                        <WhatsAppIcon className="h-5 w-5" />
                        Scrivici su WhatsApp
                    </a>
                    <p className="mt-3 text-center text-xs font-semibold uppercase tracking-widest text-ink/60">
                        {BRAND}
                    </p>
                </nav>
            )}
        </header>
    );
};
